import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-relatorio-alimentacao',
  templateUrl: './relatorio-alimentacao.component.html',
  styleUrls: ['./relatorio-alimentacao.component.css']
})
export class RelatorioAlimentacaoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
